import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import { useTranslation } from 'react-i18next';

import cptimg from './cpt_icon_saas.png';
import borimg from './borehole_icon_saas.png';
import dvp from './sviluppo.png';
import tut from './tutorial.png';

function Sw_tutorial() {

    const { t } = useTranslation();
    const navigate = useNavigate(); // Create a navigate function

    const user = JSON.parse(localStorage.getItem('user'));
    const username = user ? user.username : null;

    const videoscpt = [
      {
        id: "txFbLUTlj7Q",
        title: "Elaborazione CPTU"
      },
    ];

    const videosbhr = [

    ];

    return(
        <div className="main-wrapper">
            <div className="tools-wrapperS1" id="id1">
                <div className="title-sez1">Video CPT</div>
                    <div className="sez1">
                      <div className="video-scroll">

                        {videoscpt.map((video) => (

                          <div key={video.id} className="video-card">
                            <iframe
                              width="480"
                              height="270"
                              src={`https://www.youtube.com/embed/${video.id}`}
                              title={video.title}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            />
                            <div className="video-title">{video.title}</div>
                          </div>
                        ))}
                      </div>
                    </div>
            </div>

            <div className="tools-wrapperS2" id="id2">
               <div className="title-sez2">-</div>
                <div className="sez2" >
                    <div className="video-scroll">
                        {videosbhr.map((video) => (
                          <div key={video.id} className="video-card">
                            <iframe
                              width="480"
                              height="270"
                              src={`https://www.youtube.com/embed/${video.id}`}
                              title={video.title}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            />
                            <div className="video-title">{video.title}</div>
                          </div>
                        ))}
                      </div>
                    </div>
            </div>
      </div>

    );
}


export default Sw_tutorial;

